module.exports = __webpack_public_path__ + "static/img/m_order.3b38fb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_order.png
// module id = mdAk
// module chunks = 9